export type HeaderSize = 'sm' | 'md' | 'lg';

export interface SizeStyles {
  icon: string;
  title: string;
  description: string;
}

export function getHeaderSizeStyles(size: HeaderSize): SizeStyles {
  const sizeStyles: Record<HeaderSize, SizeStyles> = {
    sm: {
      icon: 'size-4', // 16px
      title: 'text-title-xsmall',
      description: 'text-body-xsmall',
    },
    md: {
      icon: 'size-5', // 20px
      title: 'text-title-small',
      description: 'text-body-small',
    },
    lg: {
      icon: 'size-5', // 20px
      title: 'text-title-medium',
      description: 'text-body-medium',
    },
  };

  return sizeStyles[size];
}

export function getHeaderPaddingClass(responsive: boolean): string {
  return responsive ? 'px-screens-layout-side' : 'px-md';
}
